export const DEFAULT_LOCALE = process.env.NODE_ENV === 'test' ? 'en' : 'fi';

export const LOCAL_STORAGE_LOCALE_KEY = 'locale';

export const SESSION_PROMPT_TIMEOUT = 1000 * 60 * 10;

// 20sec
export const SESSION_DEBUG_TIMEOUT = 1000 * 20;
